import { LandingAnimatedBackground } from '../components/landing/LandingAnimatedBackground';
import { LandingNavigation } from '../components/landing/LandingNavigation';
import { LandingHero } from '../components/landing/LandingHero';
import { LandingFeatures } from '../components/landing/LandingFeatures';
import { LandingFooter } from '../components/landing/LandingFooter';

/**
 * Public landing page with branding and marketing content.
 */
export default function LandingPage() {
  return (
    <div className="min-h-screen bg-white overflow-hidden">
      <LandingAnimatedBackground />
      <LandingNavigation />
      <LandingHero />
      <LandingFeatures />
      <LandingFooter />
    </div>
  );
}
